enum Spin3dTilesTypes {
  spin3d = 'spin3d',
  spinEfficiency = 'spinEfficiency',
  measuredTilt = 'measuredTilt',
  activeSpinRate = 'activeSpinRate',
  longitudinalAngle = 'longitudinalAngle',
}

export const Spin3dTiles = [
  Spin3dTilesTypes.spin3d,
  Spin3dTilesTypes.spinEfficiency,
  Spin3dTilesTypes.measuredTilt,
  Spin3dTilesTypes.activeSpinRate,
  Spin3dTilesTypes.longitudinalAngle,
];
